import React, { useEffect, useState } from "react";
import moment from "moment";
import { Modal, Loader } from "components";
import { ReactComponent as WarningIcon } from "icons/warning.svg";
import { client_v2 } from "utils/api";
import { toastr } from "react-redux-toastr";

const UserAdjustmentsModal = ({ packer_id, date, handleClose }) => {
  const [is_loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    getData();
  }, [date, packer_id]);

  const getData = async () => {
    try {
      const res = await client_v2.get(
        `/stats/user_adjustments?packer_id=${packer_id}&date=${date}`
      );
      setData(res.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleClose();
      toastr.error("Błąd", "Wystąpił błąd podczas pobierania danych");
    }
  };

  return (
    <Modal
      no_padding
      size="md"
      handleClose={handleClose}
      header={{
        title: `Uwagi z dnia ${date || ""}`,
        icon: <WarningIcon />,
      }}
    >
      {is_loading ? (
        <div className="row jc-c p-30">
          <Loader />
        </div>
      ) : (
        <ul class="dashboard__list">
          {data.map(({ id, amount, description, created_at }) => (
            <li class="dashboard__list-item" key={id}>
              <div class="m-r-15">
                <p>
                  Data zgłoszenia:{" "}
                  {moment(created_at).format("DD-MM-YYYY HH:mm")}
                </p>
                <p class="highlighted">{description}</p>
                <p
                  class={`text-bold ${
                    amount > 0 ? "text-success" : "text-danger"
                  }`}
                >
                  {amount > 0 ? "+" : ""}
                  {amount} monet
                </p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </Modal>
  );
};

export default UserAdjustmentsModal;
